import { z } from 'zod';

import { SubscriptionDTO, SubscriptionStatus } from '../me';
import { IsoDate, Page, PageQuery, Uid, Ulid } from '../primitives';

/** Subscription row with admin-only fields. */
export const CmsSubscriptionDTO = SubscriptionDTO.extend({
  userId: Uid,
  userEmail: z.string().nullable(),
  priceId: Ulid.nullable(),
  stripeSubscriptionId: z.string().nullable(),
  stripeItemId: z.string().nullable(),
  grantId: Ulid.nullable(),
  createdAt: IsoDate,
  updatedAt: IsoDate,
});
export type CmsSubscriptionDTO = z.infer<typeof CmsSubscriptionDTO>;

/** `GET /cms/subscriptions?uid=` (admin) */
export const CmsSubscriptionsQuery = PageQuery.extend({
  uid: Uid.optional(),
  status: SubscriptionStatus.optional(),
  productId: z.string().optional(),
});
export type CmsSubscriptionsQuery = z.infer<typeof CmsSubscriptionsQuery>;
export type CmsSubscriptionsQueryInput = z.input<typeof CmsSubscriptionsQuery>;

export const CmsSubscriptionsResponse = Page(CmsSubscriptionDTO);
export type CmsSubscriptionsResponse = z.infer<typeof CmsSubscriptionsResponse>;

/** `POST /cms/subscriptions` — manual subscription (`source='manual'`). */
export const CmsSubscriptionCreateBody = z.object({
  userId: Uid,
  productId: z.string().min(1),
  /** `null` = no expiry. */
  currentPeriodEnd: IsoDate.nullable().default(null),
  parentSubscriptionId: Ulid.nullable().default(null),
  notes: z.string().max(2000).optional(),
});
export type CmsSubscriptionCreateBody = z.infer<typeof CmsSubscriptionCreateBody>;
export type CmsSubscriptionCreateBodyInput = z.input<typeof CmsSubscriptionCreateBody>;

export const CmsSubscriptionResponse = z.object({ subscription: CmsSubscriptionDTO });
export type CmsSubscriptionResponse = z.infer<typeof CmsSubscriptionResponse>;

/** `POST /cms/subscriptions/:id/cancel` */
export const CmsSubscriptionCancelBody = z.object({
  /** Cancel immediately (default) or at the end of the current period. */
  atPeriodEnd: z.boolean().default(false),
  reason: z.string().max(500).optional(),
});
export type CmsSubscriptionCancelBody = z.infer<typeof CmsSubscriptionCancelBody>;
export type CmsSubscriptionCancelBodyInput = z.input<typeof CmsSubscriptionCancelBody>;

export const CmsSubscriptionCancelResponse = CmsSubscriptionResponse;
export type CmsSubscriptionCancelResponse = z.infer<typeof CmsSubscriptionCancelResponse>;
